import PlanSimulation from "./PlanSimulation";

export default PlanSimulation;